import { Utils } from "../utils"

class Highlight extends IntersectionObserver {
    constructor(highlight) {
        super(entries =>
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    this.unobserve(entry.target)
                    highlight.classList.add("show")
                }
            })
        )

        this.observe(highlight)
    }
}

document.querySelectorAll("em")
    .forEach((highlight) => {
        // eslint-disable-next-line sonarjs/constructor-for-side-effects
        new Highlight(highlight)

        highlight.style.setProperty("--delay", (Utils.basicRandomValue() + 1) + "s")
        highlight.style.setProperty("--offset", (Utils.basicRandomValue() + 1) * 50 + "%")
        highlight.style.setProperty("--border", Array.from(
            { length: 4 },
            () => (Utils.basicRandomValue() + 2) + "em"
        ).join(" "))
    })